// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 3: GESÙ CRISTO
// ============================================================================
// Livelli 27-39 (13 livelli, 39 domande)

export const chapter3Translations = {
  name: 'Gesù Cristo',
  description: 'Il Verbo si fece carne... Conoscere Cristo è la vita eterna',
  
  spiritualWisdom: {
    principle: 'Conoscere Gesù Cristo è la vita eterna',
    scripture: 'Questa è la vita eterna: che conoscano te, il solo vero Dio, e colui che hai mandato, Gesù Cristo (Giovanni 17:3)',
    application: 'Ogni aspetto della vita di Gesù rivela Dio e nutre la nostra anima per l\'eternità'
  },
  
  levels: {
    27: {
      name: 'L\'Annunciazione',
      challenge: 'L\'angelo Gabriele fu mandato da Dio in una città della Galilea...',
      easy: {
        question: 'Quale angelo annunciò a Maria che avrebbe portato Gesù?',
        options: ['Michele', 'Gabriele', 'Raffaele', 'Uriele'],
        hint: 'L\'angelo messaggero di Dio',
        funFact: '👼 Gabriele significa Forza di Dio - l\'angelo dei grandi annunci!'
      },
      medium: {
        question: 'Quale fu la prima reazione di Maria a questo annuncio?',
        options: [
          'Gioia immediata',
          'Incredulità totale',
          'Turbamento e la domanda Come avverrà questo?',
          'Paura'
        ],
        hint: 'Una domanda pratica e legittima',
        funFact: '🤔 Maria pone una domanda logica ma mantiene un cuore aperto a Dio!'
      },
      hard: {
        question: 'Cosa ci insegna la sottomissione di Maria alla volontà divina?',
        options: [
          'La passività davanti alle prove',
          'La fede che confida anche senza capire tutto',
          'L\'obbedienza cieca',
          'La rassegnazione'
        ],
        hint: 'Si tratta di fidarsi di Dio anche nell\'ignoto',
        funFact: '🙏 Avvenga in me secondo la tua parola - modello di fede fiduciosa!'
      }
    },
    
    28: {
      name: 'La Natività',
      challenge: 'Diede alla luce il suo figlio primogenito, lo avvolse in fasce e lo pose in una mangiatoia...',
      easy: {
        question: 'In quale città nacque Gesù?',
        options: ['Nazareth', 'Gerusalemme', 'Betlemme', 'Cafarnao'],
        hint: 'La città di Davide',
        funFact: '🏘️ Betlemme significa Casa del pane - Gesù, pane di vita!'
      },
      medium: {
        question: 'Chi furono i primi a ricevere l\'annuncio della nascita?',
        options: [
          'I magi',
          'I pastori nei campi',
          'I sacerdoti del Tempio',
          'La famiglia di Maria'
        ],
        hint: 'Gente semplice che custodiva i propri greggi',
        funFact: '🐑 Dio annuncia prima agli umili pastori - il Vangelo per tutti!'
      },
      hard: {
        question: 'Cosa simboleggia Gesù nato in una mangiatoia?',
        options: [
          'La povertà dei suoi genitori',
          'L\'umiltà di Dio che si abbassa fino a noi',
          'La mancanza di posto',
          'La semplicità rurale'
        ],
        hint: 'Si tratta dell\'incarnazione divina nell\'umiltà',
        funFact: '👶 Il Creatore dell\'universo nasce in una stalla - amore infinito!'
      }
    },

    29: {
      name: 'I Magi d\'Oriente',
      challenge: 'Dei magi dall\'Oriente arrivarono a Gerusalemme e domandarono...',
      easy: {
        question: 'Cosa guidò i magi verso Gesù?',
        options: ['Un angelo', 'Una stella', 'Una visione', 'Una mappa'],
        hint: 'Un astro nel cielo',
        funFact: '⭐ La stella rappresenta che Gesù è la luce delle nazioni!'
      },
      medium: {
        question: 'Quali doni offrirono i magi?',
        options: [
          'Cibo',
          'Oro, incenso e mirra',
          'Vesti preziose',
          'Giocattoli'
        ],
        hint: 'Tre doni simbolici e preziosi',
        funFact: '🎁 Oro (regalità), incenso (divinità), mirra (sacrificio) - tutta la missione di Gesù!'
      },
      hard: {
        question: 'Cosa rappresentano questi magi pagani nel piano di Dio?',
        options: [
          'La superiorità di altre religioni',
          'L\'universalità della salvezza offerta a tutti i popoli',
          'La ricchezza materiale',
          'La scienza antica'
        ],
        hint: 'Si tratta dell\'apertura della salvezza a tutte le nazioni',
        funFact: '🌍 I magi prefigurano il Vangelo che raggiungerà il mondo intero!'
      }
    },

    30: {
      name: 'Il Battesimo di Gesù',
      challenge: 'Appena battezzato, Gesù uscì dall\'acqua...',
      easy: {
        question: 'Chi battezzò Gesù?',
        options: ['Pietro', 'Giovanni Battista', 'Andrea', 'Giacomo'],
        hint: 'Il precursore di Gesù',
        funFact: '🌊 Giovanni Battista si riteneva indegno di sciogliere i sandali di Gesù!'
      },
      medium: {
        question: 'Cosa scese su Gesù al suo battesimo?',
        options: [
          'Una luce',
          'Una colomba (lo Spirito Santo)',
          'Un angelo',
          'Solo una voce'
        ],
        hint: 'L\'uccello simbolo della pace',
        funFact: '🕊️ La colomba rivela l\'unzione divina per iniziare il ministero!'
      },
      hard: {
        question: 'Perché Gesù, senza peccato, si fece battezzare?',
        options: [
          'Per dare l\'esempio',
          'Per compiere ogni giustizia e identificarsi con noi',
          'Per obbligo religioso',
          'Per ricevere il perdono'
        ],
        hint: 'Si tratta di solidarietà con l\'umanità peccatrice',
        funFact: '❤️ Gesù si identifica totalmente con noi per salvarci meglio!'
      }
    },

    31: {
      name: 'La Tentazione nel Deserto',
      challenge: 'Gesù fu condotto dallo Spirito nel deserto per essere tentato dal diavolo...',
      easy: {
        question: 'Quanto tempo digiunò Gesù nel deserto?',
        options: ['30 giorni', '40 giorni', '50 giorni', '60 giorni'],
        hint: 'Il numero biblico della prova',
        funFact: '🏜️ Come Mosè ed Elia, 40 giorni di preparazione spirituale intensa!'
      },
      medium: {
        question: 'Come respinse Gesù ogni tentazione?',
        options: [
          'Con la propria forza',
          'Citando le Scritture',
          'Ignorando Satana',
          'Solo pregando'
        ],
        hint: 'L\'arma spirituale per eccellenza',
        funFact: '📖 Sta scritto... - la Parola di Dio, spada dello Spirito!'
      },
      hard: {
        question: 'Cosa ci insegna la tentazione di Gesù sui nostri combattimenti?',
        options: [
          'Le tentazioni sono peccato',
          'La tentazione può essere vinta dalla Parola e dalla fede',
          'Bisogna fuggire da ogni deserto',
          'Solo Gesù può resistere'
        ],
        hint: 'Si tratta della nostra strategia contro le tentazioni',
        funFact: '⚔️ Gesù ci mostra come vincere: Parola di Dio + fede attiva!'
      }
    },

    32: {
      name: 'I Primi Discepoli',
      challenge: 'Gesù disse loro: Seguitemi e vi farò pescatori di uomini...',
      easy: {
        question: 'Qual era il mestiere di Pietro e Andrea?',
        options: ['Pastori', 'Pescatori', 'Carpentieri', 'Esattori delle tasse'],
        hint: 'Un mestiere sul lago di Galilea',
        funFact: '🎣 Gesù trasforma i pescatori di pesci in pescatori di anime!'
      },
      medium: {
        question: 'Come reagirono i primi discepoli alla chiamata?',
        options: [
          'Esitarono a lungo',
          'Chiesero prove',
          'Lasciarono tutto e lo seguirono subito',
          'Contrattarono'
        ],
        hint: 'Una risposta immediata e totale',
        funFact: '🚶 L\'autorità di Gesù era così evidente che obbedirono istantaneamente!'
      },
      hard: {
        question: 'Cosa significa seguire Gesù nella nostra epoca?',
        options: [
          'Abbandonare il lavoro',
          'Vivere secondo i suoi insegnamenti e la sua volontà',
          'Unirsi a una comunità isolata',
          'Fare solo proselitismo'
        ],
        hint: 'Si tratta di una trasformazione di vita e di priorità',
        funFact: '✨ Seguire Gesù trasforma il nostro cuore, le nostre scelte, il nostro destino!'
      }
    },

    33: {
      name: 'Il Discorso della Montagna',
      challenge: 'Beati i poveri in spirito, perché di loro è il regno dei cieli...',
      easy: {
        question: 'Qual è la prima beatitudine del Discorso della Montagna?',
        options: [
          'Beati i puri di cuore',
          'Beati i poveri in spirito',
          'Beati i miti',
          'Beati gli operatori di pace'
        ],
        hint: 'Si riferisce all\'umiltà spirituale',
        funFact: '😊 I poveri in spirito conoscono il loro bisogno di Dio - porta del Regno!'
      },
      medium: {
        question: 'Cosa disse Gesù sugli operatori di pace?',
        options: [
          'Saranno fortunati',
          'Saranno chiamati figli di Dio',
          'Saranno amati',
          'Saranno potenti'
        ],
        hint: 'Un\'identità divina speciale',
        funFact: '👑 I pacificatori assomigliano a Dio - testimonianza vivente della Sua natura!'
      },
      hard: {
        question: 'Come le beatitudini rovesciano i valori del mondo?',
        options: [
          'Condannando la ricchezza',
          'Isolando i credenti',
          'Dichiarando beati coloro che il mondo disprezza',
          'Abolendo le leggi'
        ],
        hint: 'Si tratta di valori divini contrari a quelli mondani',
        funFact: '🔄 Le beatitudini trasformano la nostra visione di felicità e successo!'
      }
    },

    34: {
      name: 'Le Parabole del Regno',
      challenge: 'Egli insegnò loro molte cose in parabole...',
      easy: {
        question: 'Nella parabola del seminatore, cosa rappresenta il seme?',
        options: [
          'Il denaro',
          'La Parola di Dio',
          'Le buone opere',
          'L\'amore'
        ],
        hint: 'Ciò che Gesù proclama e insegna',
        funFact: '🌱 La Parola di Dio germoglia e cresce nei nostri cuori!'
      },
      medium: {
        question: 'Nella parabola del granello di senape, cosa simboleggia questo seme minuscolo?',
        options: [
          'La debolezza umana',
          'Il Regno che inizia piccolo ma diventa grande',
          'L\'importanza dei dettagli',
          'La natura'
        ],
        hint: 'Qualcosa che cresce in modo impressionante',
        funFact: '🌳 Dal seme più piccolo nasce un grande albero - potenza del Regno!'
      },
      hard: {
        question: 'Perché Gesù insegnava in parabole?',
        options: [
          'Per complicare il Suo messaggio',
          'Per rivelare verità spirituali attraverso immagini familiari',
          'Per mancanza di tempo',
          'Per testare l\'intelligenza'
        ],
        hint: 'Si tratta di rendere accessibili i misteri del Regno',
        funFact: '💡 Le parabole rivelano ai cuori aperti e nascondono ai cuori chiusi!'
      }
    },

    35: {
      name: 'I Miracoli di Gesù',
      challenge: 'Egli calmò la tempesta e disse al mare: Taci! Calmati!...',
      easy: {
        question: 'Con quanti pani Gesù sfamò 5000 uomini?',
        options: ['3 pani', '5 pani', '7 pani', '12 pani'],
        hint: 'Lo stesso numero dei pesci',
        funFact: '🍞 5 pani e 2 pesci diventano un banchetto - generosità divina!'
      },
      medium: {
        question: 'Cosa dissero i discepoli quando Gesù calmò la tempesta?',
        options: [
          'È un mago',
          'Chi è costui al quale anche il vento e il mare obbediscono?',
          'È normale',
          'Dobbiamo andarcene'
        ],
        hint: 'Una domanda sull\'identità di Gesù',
        funFact: '⛈️ Anche gli elementi riconoscono il loro Creatore e Signore!'
      },
      hard: {
        question: 'Qual è lo scopo principale dei miracoli di Gesù?',
        options: [
          'Impressionare le folle',
          'Rivelare la Sua divinità e manifestare l\'amore di Dio',
          'Guadagnare influenza',
          'Aiutare solo materialmente'
        ],
        hint: 'Si tratta di rivelazione divina e compassione',
        funFact: '❤️ Ogni miracolo rivela il cuore di Dio: amore, compassione, potenza!'
      }
    },

    36: {
      name: 'La Trasfigurazione',
      challenge: 'E fu trasfigurato davanti a loro; il suo volto risplendette come il sole...',
      easy: {
        question: 'Quali discepoli videro Gesù trasfigurato?',
        options: [
          'Tutti e dodici',
          'Pietro, Giacomo e Giovanni',
          'Solo Pietro e Giovanni',
          'Le donne che lo seguivano'
        ],
        hint: 'Il cerchio ristretto dei tre',
        funFact: '⛰️ Pietro, Giacomo e Giovanni: testimoni privilegiati della gloria divina!'
      },
      medium: {
        question: 'Quali figure dell\'Antico Testamento apparvero?',
        options: [
          'Abramo e Isacco',
          'Davide e Salomone',
          'Mosè ed Elia',
          'Adamo e Noè'
        ],
        hint: 'Il rappresentante della Legge e quello dei Profeti',
        funFact: '📜 Mosè (Legge) ed Elia (Profeti) testimoniano di Gesù!'
      },
      hard: {
        question: 'Cosa rivela questa trasfigurazione sulla natura di Gesù?',
        options: [
          'È un grande profeta',
          'La Sua divinità nascosta si rivela temporaneamente',
          'Controlla la luce',
          'Può cambiare aspetto'
        ],
        hint: 'Si tratta della rivelazione della Sua natura divina',
        funFact: '✨ La gloria divina di Gesù risplende - anticipo della Sua risurrezione!'
      }
    },

    37: {
      name: 'L\'Entrata Trionfale',
      challenge: 'Osanna al Figlio di Davide! Benedetto colui che viene nel nome del Signore!...',
      easy: {
        question: 'Su quale animale entrò Gesù a Gerusalemme?',
        options: ['Cavallo', 'Asino', 'Cammello', 'A piedi'],
        hint: 'Animale simbolo di umiltà e pace',
        funFact: '🐴 L\'asino simboleggia il Re umile che viene in pace, non in guerra!'
      },
      medium: {
        question: 'Cosa gridò la folla accogliendo Gesù?',
        options: [
          'Viva il Re!',
          'Osanna! Benedetto colui che viene nel nome del Signore!',
          'Gloria a Dio!',
          'Libertà!'
        ],
        hint: 'Un grido di gioia e benedizione',
        funFact: '🌿 "Osanna" significa "salva ora" - invocazione di salvezza divina!'
      },
      hard: {
        question: 'Perché questa entrata è "trionfale" ma tragica?',
        options: [
          'C\'erano poche persone',
          'La folla che lo acclama lo rifiuterà tra 5 giorni',
          'Le autorità erano assenti',
          'Pioveva'
        ],
        hint: 'Si tratta dell\'incostanza del cuore umano',
        funFact: '💔 La stessa folla griderà "Crocifiggilo!" pochi giorni dopo!'
      }
    },

    38: {
      name: 'L\'Ultima Cena',
      challenge: 'Prendete e mangiate, questo è il mio corpo dato per voi...',
      easy: {
        question: 'Cosa fece Gesù ai piedi dei suoi discepoli?',
        options: [
          'Li benedisse',
          'Li lavò',
          'Li profumò',
          'Li baciò'
        ],
        hint: 'Un gesto di umiltà e servizio',
        funFact: '🦶 Il Maestro diventa servo - rivoluzione di amore e umiltà!'
      },
      medium: {
        question: 'Cosa istituì Gesù durante questa cena?',
        options: [
          'Il battesimo',
          'L\'Eucaristia (Santa Cena)',
          'Il Padre Nostro',
          'Il digiuno'
        ],
        hint: 'Un sacramento con pane e vino',
        funFact: '🍞🍷 Pane e vino diventano simboli eterni di sacrificio e amore!'
      },
      hard: {
        question: 'Cosa significa "Fate questo in memoria di me"?',
        options: [
          'Ripetete questa cena',
          'Celebrate la mia morte e risurrezione finché non torno',
          'Ricordate le mie parole',
          'Amatevi gli uni gli altri'
        ],
        hint: 'Si tratta di una commemorazione vivente e profetica',
        funFact: '⏳ Ogni Eucaristia annuncia la morte del Signore fino al Suo ritorno!'
      }
    },

    39: {
      name: 'Getsemani',
      challenge: 'Padre mio, se è possibile, passi da me questo calice...',
      easy: {
        question: 'Dove pregò Gesù prima del suo arresto?',
        options: [
          'Nel Tempio',
          'Nel giardino del Getsemani',
          'Sul Monte degli Ulivi',
          'A casa di amici'
        ],
        hint: 'Un giardino di ulivi',
        funFact: '🫒 Getsemani significa "frantoio" - luogo di pressione intensa!'
      },
      medium: {
        question: 'Cosa fecero i discepoli mentre Gesù pregava?',
        options: [
          'Pregarono con lui',
          'Si addormentarono',
          'Montarono la guardia',
          'Se ne andarono'
        ],
        hint: 'Non riuscirono a vegliare nemmeno un\'ora',
        funFact: '😴 Lo spirito è pronto ma la carne è debole - fragilità umana!'
      },
      hard: {
        question: 'Cosa rivela l\'agonia di Gesù sulla sua natura?',
        options: [
          'Era solo uomo',
          'Era pienamente uomo e pienamente Dio',
          'Dubitava della sua missione',
          'Era debole'
        ],
        hint: 'Si tratta del mistero dell\'Incarnazione',
        funFact: '✝️ Gesù porta pienamente l\'angoscia umana rimanendo fedele a Dio!'
      }
    }
  }
};

export default chapter3Translations;
